import React, { cloneElement, useEffect, useRef, useState } from 'react';

interface Props {
  align?: 'left' | 'right';
  children: any;
}

const Dropdown: (React.FC<Props> & { Caret: any; Trigger: any; }) = (props) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const align = props.align || 'left';

  const closeDropdown = useRef(() => {
    setIsExpanded(false);
  });

  useEffect(() => {
    if (isExpanded) {
      document.addEventListener('click', closeDropdown.current);
    } else {
      document.removeEventListener('click', closeDropdown.current);
    }

    return () => {
      document.removeEventListener('click', closeDropdown.current);
    }
  }, [isExpanded]);

  const triggerChild = React.Children.toArray(props.children).find((child) => (
    (child as React.ReactElement<any>).type === Dropdown.Trigger
  )) as React.ReactElement<any>;

  return (
    <>
      {
        cloneElement(
          triggerChild,
          {
            ...triggerChild.props,
            onClick: () => setIsExpanded(!isExpanded)
          }
        )
      }

      <div
        style={{
          background: '#ffffff',
          border: isExpanded ? '1px solid rgba(0,0,0,.15)' : 'none',
          boxShadow: isExpanded ? '0 6px 12px rgba(0, 0, 0, .175)' : 'none',
          display: isExpanded ? 'block' : 'none',
          left: align === 'left' ? 0 : 'auto',
          marginTop: 2,
          minWidth: 160,
          overflow: 'hidden',
          position: 'absolute',
          right: align === 'right' ? 0 : 'auto',
          top: '100%',
          zIndex: 1000
        }}
      >
        <div>
          {
            React.Children.toArray(props.children).filter((child) => (
              (child as React.ReactElement<any>).type !== Dropdown.Trigger
            ))
          }
        </div>
      </div>
    </>
  );
};

Dropdown.Caret = () => {
  return (
    <div
      style={{
        borderLeft: '5px solid transparent',
        borderRight: '5px solid transparent',
        borderTop: '5px solid #B2B2B2',
        height: 0,
        width: 0
      }}
    />
  );
};

Dropdown.Trigger = (props) => {
  return (
    <div onClick={props.onClick} style={{ cursor: 'pointer', ...(props.style || {}) }}>
      {props.children}
    </div>
  );
};

export default Dropdown;
